import ActivityCard from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";
import ProductionCardContent from "./ProductionActivityCardContent";

interface Props {
  activity: server.dto.ProductionActivity
}

const ProductionActivityRowCard = (props: Props) => {
  const { activity } = props;
  const { timestampUtc } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  return <ActivityCard
    activity={activity}
    getTitle={() => activity.action.text}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}
  >
    <ProductionCardContent activity={activity} />
  </ActivityCard>;
};

export default ProductionActivityRowCard;